var _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _rect5, _rect6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLockChange = function SvgLockChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 18.333,
    width: 35,
    height: 63.333,
    rx: 5,
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.167,
    y: 53.333,
    width: 21.667,
    height: 21.667,
    rx: 10.833,
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 62.5c-.92 0-1.667.746-1.667 1.667v2.846a4.167 4.167 0 103.334 0v-2.846c0-.92-.747-1.667-1.667-1.667z",
    fill: "#F8F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.333 67.013l.334.764.5-.218v-.546h-.834zm3.334 0h-.834v.546l.5.218.334-.764zm-2.5-2.846c0-.46.373-.834.833-.834v-1.666a2.5 2.5 0 00-2.5 2.5h1.667zm0 2.846v-2.846H47.5v2.846h1.667zm-2.5 3.82c0-1.365.821-2.54 2-3.056L48 66.25c-1.764.77-3 2.532-3 4.583h1.667zM50 74.167a3.333 3.333 0 01-3.333-3.334H45a5 5 0 005 5v-1.666zm3.333-3.334A3.333 3.333 0 0150 74.167v1.666a5 5 0 005-5h-1.667zm-2-3.056c1.18.515 2 1.69 2 3.056H55a5.001 5.001 0 00-3-4.583l-.667 1.527zm-.5-3.61v2.846H52.5v-2.846h-1.667zM50 63.333c.46 0 .833.373.833.834H52.5a2.5 2.5 0 00-2.5-2.5v1.666z",
    fill: "#332C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.667,
    y: 45,
    width: 21.667,
    height: 21.667,
    rx: 10.833,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 54.167c-.92 0-1.667.746-1.667 1.666v2.847a4.168 4.168 0 103.334 0v-2.847c0-.92-.747-1.666-1.667-1.666z",
    fill: "#F8F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.833 58.68l.334.764.5-.219v-.545h-.834zm3.334 0h-.834v.545l.5.219.334-.764zm-2.5-2.847c0-.46.373-.833.833-.833v-1.667a2.5 2.5 0 00-2.5 2.5h1.667zm0 2.847v-2.847H30v2.847h1.667zm-2.5 3.82c0-1.365.821-2.541 2-3.056l-.667-1.528c-1.764.771-3 2.533-3 4.584h1.667zm3.333 3.333a3.333 3.333 0 01-3.333-3.333H27.5a5 5 0 005 5v-1.667zm3.333-3.333a3.333 3.333 0 01-3.333 3.333V67.5a5 5 0 005-5h-1.667zm-2-3.056c1.18.515 2 1.69 2 3.056H37.5a5.001 5.001 0 00-3-4.584l-.667 1.528zm-.5-3.61v2.846H35v-2.847h-1.667zM32.5 55c.46 0 .833.373.833.833H35a2.5 2.5 0 00-2.5-2.5V55z",
    fill: "#332C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 26.667,
    width: 10,
    height: 45,
    rx: 5,
    transform: "rotate(90 90 26.667)",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 36.667,
    width: 10,
    height: 10,
    rx: 5,
    transform: "rotate(-180 55 36.667)",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })));
};

export default SvgLockChange;